import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const footerLinks = {
  company: [
    { label: 'About Us', href: '#' },
    { label: 'Careers', href: '#' },
    { label: 'Press', href: '#' },
  ],
  services: [
    { label: 'Express Shipping', href: '#' },
    { label: 'Freight Services', href: '#' },
    { label: 'Warehousing', href: '#' },
  ],
  support: [
    { label: 'Help Center', href: '#' },
    { label: 'Track Shipment', href: '/track-shipment' },
    { label: 'Contact Us', href: '/contact' },
  ],
  legal: [
    { label: 'Privacy Policy', href: '#' },
    { label: 'Terms of Service', href: '#' },
    { label: 'Cookie Policy', href: '#' },
  ],
};

const socialLinks = [
  { name: 'Facebook', icon: 'facebook', href: '#' },
  { name: 'Twitter', icon: 'twitter', href: '#' },
  { name: 'LinkedIn', icon: 'linkedin', href: '#' },
  { name: 'Instagram', icon: 'instagram', href: '#' },
];

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Company</h3>
            <ul className="space-y-3">
              {footerLinks?.company?.map((link) => (
                <li key={link?.label}>
                  <Link href={link?.href} className="text-sm hover:text-white transition-colors">
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Services</h3>
            <ul className="space-y-3">
              {footerLinks?.services?.map((link) => (
                <li key={link?.label}>
                  <Link href={link?.href} className="text-sm hover:text-white transition-colors">
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Support</h3>
            <ul className="space-y-3">
              {footerLinks?.support?.map((link) => (
                <li key={link?.label}>
                  <Link href={link?.href} className="text-sm hover:text-white transition-colors">
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Legal</h3>
            <ul className="space-y-3">
              {footerLinks?.legal?.map((link) => (
                <li key={link?.label}>
                  <Link href={link?.href} className="text-sm hover:text-white transition-colors">
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2">
            <Icon name="public/assets/images/ChatGPT_Image_Feb_7_2026_02_48_47_AM-1770428942096.png" size={24} className="text-primary" />
            <span className="text-xl font-heading font-semibold text-white">Dream work shipping</span>
          </div>

          <div className="flex items-center gap-6">
            {socialLinks?.map((social) => (
              <Link
                key={social?.name}
                href={social?.href}
                className="text-slate-400 hover:text-white transition-colors"
                aria-label={social?.name}
              >
                <Icon name="GlobeAltIcon" size={20} />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}